import styled from "styled-components";

const FilesystemWrapper = styled.div`
  height: 100%;
  display: inline-block;
`;

export default FilesystemWrapper;
